/**
 * Sync measured header height for sticky offsets; collapse mobile promo on scroll.
 * Mobile nav is portaled to <body> so it is not clipped by the sticky header group.
 */
(function () {
  var group = document.querySelector('.shopify-section-group-header-group');
  if (!group) return;

  var mobileQuery = window.matchMedia('(max-width: 720px)');

  function syncHeaderOffset() {
    document.documentElement.style.setProperty(
      '--site-header-offset',
      group.offsetHeight + 'px'
    );
  }

  function syncScrollState() {
    if (!mobileQuery.matches) {
      group.classList.remove('is-scrolled');
      return;
    }
    group.classList.toggle('is-scrolled', (window.scrollY || 0) > 10);
  }

  function portalMobileNav() {
    var nav = document.getElementById('mobile-nav');
    var main = document.getElementById('MainContent');
    if (!nav || !main || nav.dataset.portaled === 'true') return;
    if (!nav.closest('.shopify-section-group-header-group')) {
      nav.dataset.portaled = 'true';
      return;
    }
    document.body.insertBefore(nav, main);
    nav.dataset.portaled = 'true';
  }

  function bindMobileNav() {
    var btn = document.getElementById('hamburger-btn');
    var nav = document.getElementById('mobile-nav');
    if (!btn || !nav || btn.dataset.bound === 'true') return;
    btn.dataset.bound = 'true';

    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('is-open');
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  portalMobileNav();
  bindMobileNav();
  syncHeaderOffset();
  syncScrollState();

  window.addEventListener('scroll', syncScrollState, { passive: true });
  window.addEventListener('resize', syncHeaderOffset, { passive: true });

  if (typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(function () {
      syncHeaderOffset();
    });
    ro.observe(group);
  }
})();
